module.exports = __webpack_public_path__ + "media/images/bank_images/santander-65ac1ea8ac45a74be6d2be58a8f21960.png";